import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { generateBuySellReportService } from 'services';

const adapter = createEntityAdapter({
  // Assume IDs are stored in a field other than `id`
  // selectId: (deliveryScheduleDay) => _.get(deliveryScheduleDay, 'delivery_start_date_string', 0),
  // Keep the "all IDs" array sorted based on book titles
  // sortComparer: (a, b) => (a.name_of_farm || '').localeCompare(b.name_of_farm || ''),
});

const slice = createSlice({
  name: 'buySellTrackerReport',
  // initialState: booksAdapter.getInitialState(),
  initialState: adapter.getInitialState({
    busy: false,
    reportData: [],
  }),
  // initialState: { ids: [], entities: {}, dirty: true },
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    getReportData: (state, { payload }) => ({ ...state, reportData: payload }),
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const fetchList = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await generateBuySellReportService.fetchList(params);
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const generateReport = (params) => async (dispatch) => {
  try {
    let resData;
    if (params?.isMissedCall) {
      resData = await generateBuySellReportService.getReportData(params);
      dispatch(slice.actions.getReportData(resData));
    } else {
      resData = await generateBuySellReportService.fetchList(params);
    }
    return resData;
  } catch (err) {
    utils.displayErrors(err);
  }
};

const getGridData = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await generateBuySellReportService.getReportData(params, 'commodity_req_offer_response_id');
    dispatch(slice.actions.getReportData(resData));
    dispatch(slice.actions.setBusy(false));
    return resData;
  } catch (err) {
    utils.displayErrors(err);
    dispatch(slice.actions.setBusy(false));
  }
};

const getReportData = (params) => async (dispatch) => {
  try {
    const resData = await generateBuySellReportService.getReportData(params, 'commodity_req_offer_response_id');
    dispatch(slice.actions.getReportData(resData));
    return resData;
  } catch (err) {
    utils.displayErrors(err);
  }
};
// const platformChargesReportData = (params) => async (dispatch) => {
//   dispatch(slice.actions.setBusy(true));
//   try {
//     const resData = await generateBuySellReportService.platformChargesReportData(params);
//     dispatch(slice.actions.setAll(resData));
//   } catch (err) {
//     dispatch(slice.actions.setAll({}));
//     utils.displayErrors(err);
//   }
//   dispatch(slice.actions.setBusy(false));
// };

const getEmissionsSustainabilityReport = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await generateBuySellReportService.getEmissionsSustainabilityReport(params);
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const platformChargesReportData = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await generateBuySellReportService.platformChargesReportData(params);
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

// const getEmissionsSustainabilityReport = (params) => async (dispatch) => {
//   dispatch(slice.actions.setBusy(true));
//   try {
//     const resData = await generateBuySellReportService.getEmissionsSustainabilityReport(params);
//     dispatch(slice.actions.setAll(resData));
//   } catch (err) {
//     dispatch(slice.actions.setAll({}));
//     utils.displayErrors(err);
//   }
//   dispatch(slice.actions.setBusy(false));
// };
const actions = {
  ...slice.actions,
  fetchList,
  generateReport,
  getGridData,
  getReportData,
  platformChargesReportData,
  getEmissionsSustainabilityReport,
};

// // Rename the exports for readability in component usage
// export const {
//   selectById: selectUserById,
//   selectIds: selectUserIds,
//   selectEntities: selectUserEntities,
//   selectAll: selectAllUsers,
//   selectTotal: selectTotalUsers
// } = usersAdapter.getSelectors(state => state.users)

const selectors = {
  ...adapter.getSelectors((state) => state.payments),
};

export { actions, selectors };

export default slice.reducer;
